import { X } from 'lucide-react';
import { Box, Flex, Text, chakra } from '@chakra-ui/react';
import { Input } from '@/components/ui/Input/Input';
import type { SettingsFormReturn } from '../useSettingsForm';

export function SkillsCard({ form }: { form: SettingsFormReturn }) {
  const { skills, newSkill, setNewSkill, handleAddSkill, handleDeleteSkill } = form;
  return (
    <Box bg="white" borderRadius="2xl" p="6" boxShadow="0 8px 24px rgba(0,0,0,0.12)">
      <Text as="h3" fontSize="lg" fontWeight="semibold" color="volyx.primary" mb="4">
        Skills
      </Text>
      <Flex flexDir="column" gap="3">
        {skills.length > 0 ? (
          skills.map((skill) => (
            <Flex key={skill} align="center" justify="space-between" bg="volyx.lightGray" borderRadius="lg" px="4" py="2">
              <Text as="span" color="volyx.primary" fontSize="md">{skill}</Text>
              <chakra.button
                bg="transparent"
                border="none"
                cursor="pointer"
                color="volyx.textSecondary"
                p="1"
                borderRadius="md"
                transition="color 0.15s, background-color 0.15s"
                _hover={{ color: 'volyx.error', bg: 'white' }}
                onClick={() => handleDeleteSkill(skill)}
              >
                <X size={14} />
              </chakra.button>
            </Flex>
          ))
        ) : (
          <Text color="volyx.textSecondary" fontSize="md">No skills added yet.</Text>
        )}
        <Flex gap="2" mt="2">
          <Input
            id="new-skill"
            name="new-skill"
            autoComplete="off"
            value={newSkill}
            onChange={(e) => setNewSkill(e.target.value)}
            placeholder="Add new skill"
            maxLength={25}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddSkill();
              }
            }}
          />
          <chakra.button
            px="6"
            py="3"
            borderRadius="xl"
            fontWeight="semibold"
            transition="all 0.3s"
            cursor="pointer"
            border="none"
            bg="volyx.lightGray"
            color="volyx.text"
            _hover={{ bg: 'volyx.mediumGray', transform: 'scale(1.01)' }}
            onClick={handleAddSkill}
          >
            Add
          </chakra.button>
        </Flex>
      </Flex>
    </Box>
  );
}
